type PrizeItem = {
  value: string;
  is_big_gain: boolean;
  name?: string;
  type?: string;
  isDrawn?: boolean;
  prizeUrls?: string;
  prizeValue?: number;
};

export const sortPrizesByValue = (prizes: PrizeItem[]): PrizeItem[] => {
  if (!prizes || prizes.length === 0) {
    return [];
  }

  return [...prizes].sort((a, b) => {
    const prizeValueA = a.prizeValue ?? -1;
    const prizeValueB = b.prizeValue ?? -1;

    return prizeValueB - prizeValueA;
  });
};

export const processPrizesWithBigGain = (prizes: PrizeItem[]): PrizeItem[] => {
  if (!prizes || prizes.length === 0) {
    return [];
  }

  const sortedPrizes = sortPrizesByValue(prizes);

  const maxPrizeValue = Math.max(...sortedPrizes.map((prize) => prize.prizeValue ?? 0));

  const hasPrizes = maxPrizeValue > 0;

  return sortedPrizes.map((prize, index) => ({
    ...prize,
    is_big_gain: hasPrizes && index === 0 && (prize.prizeValue ?? 0) > 0,
  }));
};
